import { render, staticRenderFns } from "./MaterialCheckBox.vue?vue&type=template&id=bcf66452&scoped=true"
import script from "./MaterialCheckBox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckBox.vue?vue&type=script&lang=js"
import style0 from "./MaterialCheckBox.vue?vue&type=style&index=0&id=bcf66452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf66452",
  null
  
)

export default component.exports